// import React, { useState } from "react";
// import { AuthContext } from "../../context/AuthContext";
// import { API, BEARER } from "../../constant";
// import { useEffect } from "react";
// import { getToken, removeToken} from "../../helpers";
    
//     const AuthProvider = ({ children }) => {
//       const [userData, setUserData] = useState();
//       const [isLoading, setIsLoading] = useState(true);
    
//       const authToken = getToken();
    
//       const fetchLoggedInUser = async (token) => {
//         setIsLoading(true);
//         try {
//           const response = await fetch(`${API}/users/me`, {
//             headers: { Authorization: `${BEARER} ${token}` },
//           });
//           const data = await response.json();
    
//           setUserData(data);
//         } catch (error) {
//           console.error(error);
          
//         } finally {
//           setIsLoading(false);
//         }
//       };
    
//       const handleUser = (user) => {
//         setUserData(user);
//       };
      
//       const handleLogout = () => {
//           removeToken(); // Clears both localStorage and sessionStorage
//           setUserData(undefined); // Clear user state
//       };

//       useEffect(() => {
//         if (authToken) {
//           fetchLoggedInUser(authToken);
//         }
//       }, [authToken]);
    
//       return (
//         <AuthContext.Provider
//           value={{ user: userData, setUser: handleUser, logout: handleLogout, isLoading }}
//         >
//           {children}
//         </AuthContext.Provider>
//       );
//     };
    
//     export default AuthProvider;
import React, { useState, useEffect } from "react";
import { getToken, removeToken } from "../../helpers";
import { AuthContext } from "../../context/AuthContext";
import { API, BEARER } from "../../constant";

const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isTrialActive, setIsTrialActive] = useState(false);
  const [trialEndsAt, setTrialEndsAt] = useState(null);

  const checkSubscriptionStatus = async (userId, token, user) => {
    // Check trial
    if (user.trialEndsAt) {
      const trialEnd = new Date(user.trialEndsAt);
      const now = new Date();
      setTrialEndsAt(trialEnd);
      if (trialEnd > now) {
        setIsTrialActive(true);
        setIsSubscribed(false);
        return;
      }
    }

    // Check active subscription
    try {
      const res = await fetch(
        `${API}/subscriptions?publicationState=preview&filters[userId][id][$eq]=${userId}&filters[status][$eq]=active`,
        { headers: { Authorization: `${BEARER} ${token}` } }
      );
      const data = await res.json();
      const hasActive = data?.data?.length > 0;
      setIsSubscribed(hasActive);
      setIsTrialActive(false);
    } catch (err) {
      console.warn('Could not check subscription status:', err);
      setIsSubscribed(false);
    }
  };

  const fetchLoggedInUser = async (token) => {
    try {
      const response = await fetch(`${API}/users/me`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });

      if (!response.ok) {
        handleLogout();
        throw new Error('Token validation failed');
      }

      const data = await response.json();
      setUserData(data);
      await checkSubscriptionStatus(data.id, token, data);
    } catch (error) {
      console.error("Error fetching user:", error);
      setUserData(undefined);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUser = (user) => {
    setUserData(user);
    // When user is set after registration, trial is not yet set — will be set after card capture
  };

  const handleLogout = () => {
    removeToken();
    setUserData(undefined);
    setIsSubscribed(false);
    setIsTrialActive(false);
    setTrialEndsAt(null);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    const token = getToken();
    if (token) {
      fetchLoggedInUser(token);
    } else {
      setUserData(undefined);
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{ user: userData, setUser: handleUser, logout: handleLogout, isLoading, isSubscribed, isTrialActive, trialEndsAt }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
